export enum ENotificationActionType {
    DOWNLOAD = 'DOWNLOAD',
    NAVIGATE = 'NAVIGATE',
    LINK = 'LINK'
}

export enum ENotificationStatus {
    READ = 'READ',
    UNREAD = 'UNREAD',
    ARCHIVED = 'ARCHIVED'
}

export enum ENotificationType {
    JOB = 'JOB',
    JOB_DOWNLOAD = 'JOB_DOWNLOAD',
    WORKFLOW_BETWEEN_STEPS_TRANSITION = 'WORKFLOW_BETWEEN_STEPS_TRANSITION',
    WORKFLOW_DELIVERY_LINKS = 'WORKFLOW_DELIVERY_LINKS',
    NOTE_UPDATE = 'NOTE_UPDATE',
    STICKY_COMMENT = 'STICKY_COMMENT',
    STICKY_COMMENT_MENTION = 'STICKY_COMMENT_MENTION',
    DEADLINE_NOTIFICATION_BEFORE = 'DEADLINE_NOTIFICATION_BEFORE',
    DEADLINE_NOTIFICATION_AFTER = 'DEADLINE_NOTIFICATION_AFTER',
    WEBHOOK_CONSUMER = 'WEBHOOK_CONSUMER'
}

export enum ENotificationDestination {
    EMAIL = 'EMAIL',
    NOTIFICATION_CENTRE = 'NOTIFICATION_CENTRE',
    TOASTER = 'TOASTER'
}

export type NotificationTypeConfig = Record<ENotificationType, { title: string; description: string; destinations: ENotificationDestination[] }>;

export type NotificationDestinationConfig = Record<ENotificationDestination, string>;
